import { Component, OnDestroy, OnInit } from '@angular/core';
import { AgencyDao } from '../../../core/services/dao/agencyDao';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-connect-trade-desk-agency',
  templateUrl: './connect-trade-desk-agency.component.html',
  styleUrls: ['./connect-trade-desk-agency.component.scss']
})
export class ConnectTradeDeskAgencyComponent implements OnDestroy {
  public agencyName: string = '';
  public email: string;
  public password: string;
  public isValid = true;
  public loading = true;
  public complete = false;
  public loginError = '';

  private token = '';

  private subs: Array<Subscription> = [];

  constructor(private agencyDao: AgencyDao, public activatedRoute: ActivatedRoute) {
    if (!this.activatedRoute.snapshot.queryParams.token) {
      this.isValid = false;
      this.loading = false;
      this.complete = false;
    } else {
      this.token = this.activatedRoute.snapshot.queryParams.token;
      let sub = this.agencyDao.getTradeDeskInvite(this.token).subscribe(res => {
        if (res && res.valid) {
          this.agencyName = res.name;
          this.complete = res.complete;
        } else {
          this.isValid = false;
          this.complete = false;
        }
        this.loading = false;
      });
      this.subs.push(sub);
    }
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  ttdLogin(e) {
    this.loginError = '';
    this.loading = true;
    this.agencyDao.ttdLogin(this.token, this.email, this.password).subscribe(
      loginRes => {
        if (loginRes) {
          this.complete = true;
        } else {
          this.loginError = "Couldn't generate a token. Please double check your credentials and try again.";
        }
        this.loading = false;
      },
      err => {
        console.error(err);
        this.loading = false;
        this.loginError = 'Unknown error generating a token.  Try again later.';
      }
    );
  }
}
